<template>
  <transition name="header-profile-transition">
    <div class="header_profile_menu" v-show="isShow">
      <div class="header_profile_menu_top">{{ $t("contract") }}</div>
      <div
        v-if="groupedContracts && Object.keys(groupedContracts).length"
        class="header_profile_menu_contragent"
      >
        <div v-for="(contracts, counterpartyName) in groupedContracts" :key="counterpartyName">
          <div class="pl-10 pr-10 mb-10 text-base-span-xl black-2-color break-words break-all">
            {{ counterpartyName }}
          </div>
          <ul :key="contract.id" v-for="contract in contracts">
            <ContractBlock
              v-single-click="() => setActiveContract(contract)"
              style="padding-left: 10px; padding-right: 10px;"
              :name="contract.name"
              :class="[contract.name === activeContract?.name, 'cursor-pointer']"
              :active="contract.name === activeContract?.name"
              :joinDate="getContractUser(contract.id, user.id)?.joinedAt"
              :role="getContractRoleName(getContractUser(contract.id, user.id)?.roleId)"
            >
            </ContractBlock>
          </ul>
        </div>
      </div>
      <div class="grey-4-color" v-else style="padding: 20px">
        {{$t('navbar.contract_list_empty')}}
        <div class="mt-10">
          <router-link class="green-5-color" :to="{ name: 'contract.index' }">
            {{$t('navbar.create_contract')}}
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import ContractBlock from "./ContractBlock";
import { mapGetters } from "vuex";
import contractUserMixin  from "~/mixins/contractUser";
import { isMobile } from "~/mixins/isMobile";
import entityMixin from "~/mixins/entity";

export default {

  components: {
    ContractBlock,
  },
  mixins: [isMobile,
    entityMixin,
    contractUserMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: this.show
    };
  },
  methods: {
    async setActiveContract(contract) {
     await this.$store.dispatch("contract/setActiveContract", contract.id);
      this.$router.push({
        name: "contract.cabinet.index",
        params: { contractName: contract.name }
      });

      this.isShow = false;
    }
  },
  watch: {
    show: function(newVal) {
      this.isShow = newVal;
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      activeContract: "contract/activeContract"
    }),

    contractsList: function() {
      let contracts = this.$store.getters["contract/joined"];
      let contactsList = [];

      if (contracts && this.user) {
        contracts.forEach((element) => {
          if (this.isActivatedEntityStatus(element.statusId) && this.isUserInContract(element.id, this.user.id)) {
            contactsList.push(element);
          }
        });
        if (contactsList.length >= 1) {
          this.$emit("emptyList", false);
          return contactsList;
        } else {
          this.$emit("emptyList", true);
        }
      } else {
        this.$emit("emptyList", true);
      }

      return null;
    },
    groupedContracts: function() {
      const contracts = this.contractsList;
      if (!contracts) return null;
      
      const grouped = {};
      
      contracts.forEach(contract => {
        const counterpartyName = contract.counterparty?.fullName || '';
        
        if (counterpartyName) {
          if (!grouped[counterpartyName]) {
            grouped[counterpartyName] = [];
          }
          
          grouped[counterpartyName].push(contract);
        }
      });
      
      return grouped;
    }
  }
};
</script>

<style scoped>
</style>

